/* unplugin-vue-components disabled */import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Previewer from "vux/src/components/previewer/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Rater from "vux/src/components/rater/index.vue"; // this line is trasformed by vux-loader
import { calcFormula } from '@/utils/calculator';
import axios from 'axios';
export default {
  name: 'ExtField',
  components: {
    Previewer: Previewer,
    Rater: Rater
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    extFields: {
      type: Array
    },
    imgViewType: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      picList: [],
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          if (thumbnail) {
            var _thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (_thumbnail.getBoundingClientRect) {
              var rect = _thumbnail.getBoundingClientRect();
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          }
        }
      }
    };
  },
  watch: {
    extFields: {
      handler: function handler(list) {
        var _this = this;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _iterator, _step, v, url;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _iterator = _createForOfIteratorHelper(list);
                  _context.prev = 1;
                  _iterator.s();
                case 3:
                  if ((_step = _iterator.n()).done) {
                    _context.next = 12;
                    break;
                  }
                  v = _step.value;
                  if (!(v.type === 21 && !v.realPic)) {
                    _context.next = 10;
                    break;
                  }
                  _context.next = 8;
                  return _this.loadTxtImg(v.value);
                case 8:
                  url = _context.sent;
                  _this.$set(v, 'realPic', url);
                case 10:
                  _context.next = 3;
                  break;
                case 12:
                  _context.next = 17;
                  break;
                case 14:
                  _context.prev = 14;
                  _context.t0 = _context["catch"](1);
                  _iterator.e(_context.t0);
                case 17:
                  _context.prev = 17;
                  _iterator.f();
                  return _context.finish(17);
                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 14, 17, 20]]);
        }))();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    signClick: function signClick(extField, index) {
      var _this2 = this;
      this.isSignClick = true;
      this.picList = [{
        src: extField
      }];
      this.$nextTick(function () {
        _this2.$refs.previewer.show(index);
      });
    },
    loadTxtImg: function loadTxtImg(url) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (url) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return", '');
              case 2:
                if (!url.includes('data:image')) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return", url);
              case 4:
                _context2.next = 6;
                return axios({
                  method: 'get',
                  url: url
                });
              case 6:
                res = _context2.sent;
                return _context2.abrupt("return", res.data);
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleCall: function handleCall(phoneNumber) {
      this.$DingTalk.biz.telephone.showCallMenu({
        phoneNumber: phoneNumber,
        // 期望拨打的电话号码
        code: '+86',
        // 国家代号，中国是+86
        showDingCall: true,
        // 是否显示钉钉电话
        onSuccess: function onSuccess() {},
        onFail: function onFail() {}
      });
    },
    getCallNumber: function getCallNumber(form) {
      var _form$fieldAttributeL, _form$fieldAttributeL2;
      return form === null || form === void 0 ? void 0 : (_form$fieldAttributeL = form.fieldAttributeList) === null || _form$fieldAttributeL === void 0 ? void 0 : (_form$fieldAttributeL2 = _form$fieldAttributeL.find(function (v) {
        return v.type === 2001;
      })) === null || _form$fieldAttributeL2 === void 0 ? void 0 : _form$fieldAttributeL2.value;
    },
    calcValue: function calcValue(form) {
      var _form$fieldAttributeL3, _form$fieldAttributeL4;
      return calcFormula({
        formula: (form === null || form === void 0 ? void 0 : (_form$fieldAttributeL3 = form.fieldAttributeList) === null || _form$fieldAttributeL3 === void 0 ? void 0 : (_form$fieldAttributeL4 = _form$fieldAttributeL3.find(function (v) {
          return v.type === 1901;
        })) === null || _form$fieldAttributeL4 === void 0 ? void 0 : _form$fieldAttributeL4.value) || '',
        data: this.extFields,
        format: function format(p, e) {
          p[e.tfid || e.id] = e.value;
          return p;
        }
      });
    },
    spliteHyperLink: function spliteHyperLink() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      url = url || '';
      var index = url.indexOf(',') > 0 ? url.indexOf(',') : 0;
      return [url.slice(0, index), url.slice(index + 1)];
    },
    translate: function translate(str) {
      return str.slice(str.indexOf('-') + 1);
    },
    imgClick: function imgClick(extField, index) {
      var _this3 = this;
      this.picList = extField.value.split(',').map(function (item) {
        return {
          src: item
        };
      });
      this.$nextTick(function () {
        _this3.$refs.previewer.show(index);
      });
    }
  }
};